class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelectorAll(".cart-open-trigger");
		cartLink.forEach((links) => {
			links.setAttribute("role", "button");
			links.setAttribute("aria-haspopup", "dialog");
			links.addEventListener("click", (event) => {
				event.preventDefault();
				this.open(links);
			});
			links.addEventListener("keydown", (event) => {
				if (event.code.toUpperCase() === "SPACE") {
					event.preventDefault();
					this.open(links);
				}
			});
		});
	}

	open(triggeredBy) {
		$("#search-modal,.search-modal__mask").removeClass("active");
		document.querySelector('.search-pill-form').style.display = 'flex'
		$("#search-modal").removeClass('active')
		$('body').removeClass("overflow-hidden")
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {

        this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				//trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");


      
      executeInCartUpdate()
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState, nmb) {
                    document.getElementById('cart-icon-bubble').classList.remove('hidden')
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
				//console.log(parsedState)
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});
		if(nmb != 2){
			setTimeout(() => {
				this.querySelector("#CartDrawer-Overlay").addEventListener(
					"click",
					this.close.bind(this)
				);
			
			 this.open(); //-> comentar this.checkproduct y descomentar esta línea si se quiere desactivar la notificación
			/* COMPONENTE PARA NOTIFICACIÓN DE ALTA DE PRODUCTO EN EL CARRITO: K-UX */
			//this.checkProduct(parsedState);
			});
		}
	}

	/* COMPONENTE PARA NOTIFICACIÓN DE ALTA DE PRODUCTO EN EL CARRITO: K-UX */
checkProduct(item) {
  const productQuery = (productId) => ({
    query: `
      query {
        product(id: "gid://shopify/Product/${productId}") {
          id
          handle
		  metafield(namespace: "custom", key: "color") {
          value
          type
        }
		  featuredImage {
          url
          altText
        }
		  variants(first: 20) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    quantityAvailable
                    price{
                      amount
                    }
                    compareAtPrice{
                      amount
                    }
                  }
                }
              }
        }
      }
    `
  });

  const GRAPHQL_BODY = (element) => {
    return {
      method: "POST",
      headers: {
        "X-Shopify-Storefront-Access-Token": "c4a4a38a5386f5730298821c48404aad",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(productQuery(element)),
    };
  };
  fetch("https://shasamx.myshopify.com/api/2025-01/graphql.json", GRAPHQL_BODY(item.product_id))
    .then((res) => res.json())
    .then((response) => {
	  var variantID = item.variant_id
      const variant = response.data.product.variants.edges.find(edge => {
      const graphqlId = edge.node.id.split('/').pop();
      return graphqlId === variantID.toString();
    });
    if (variant) {
		var variantPrecio = variant.node.price.amount;
		var variantPrecioOriginal = variant.node.compareAtPrice?.amount || "";
		var productColor = response.data.product.metafield.value;
		var productImage= response.data.product.featuredImage.url;
		var productTalla=  variant.node.title;
		const titulo = item.product_title;
		 this.showToast({
		 			titulo: titulo,
		 			talla: productTalla,
		 			precio: variantPrecio,
		 			color:productColor,
		 			image: productImage,
		 			duration: 3000,
		 			compare_price : variantPrecioOriginal
		 		});
  
    } else {
      console.log("Variante no encontrada");
    }
    return response;
    })
    .catch(error => {
      console.log('Error en fetch: ' + error);
    });
}

	/* COMPONENTE PARA NOTIFICACIÓN DE ALTA DE PRODUCTO EN EL CARRITO: K-UX */
	showToast({ titulo = '', talla = '', precio = '', color = '', image = '', duration = 5000, compare_price = '' }) {
		const toast = document.createElement('div');
		toast.className = 'custom-toast';
		toast.innerHTML = `
			<div class="toast-content" id="abrir-cart">
				<p class="toast-ext" style="margin-bottom:5px;">EN TU BOLSA
				<svg
				width="23"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				class="icon icon-cart"
			>
				<path d="M19.0567 8H4.94329C4.77137 8.00077 4.60562 8.06125 4.47704 8.17014C4.34845 8.27903 4.26583 8.42888 4.2446 8.59167L3.00444 19.2583C2.99341 19.3513 3.003 19.4454 3.03258 19.5346C3.06217 19.6237 3.11108 19.706 3.17616 19.7759C3.24123 19.8459 3.321 19.902 3.41028 19.9406C3.49957 19.9792 3.59637 19.9994 3.69439 20H20.3056C20.4036 19.9994 20.5004 19.9792 20.5897 19.9406C20.679 19.902 20.7588 19.8459 20.8238 19.7759C20.8889 19.706 20.9378 19.6237 20.9674 19.5346C20.997 19.4454 21.0066 19.3513 20.9956 19.2583L19.7554 8.59167C19.7342 8.42888 19.6515 8.27903 19.523 8.17014C19.3944 8.06125 19.2286 8.00077 19.0567 8V8Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M8.5 7C8.5 6.20435 8.86875 5.44129 9.52513 4.87868C10.1815 4.31607 11.0717 4 12 4C12.9283 4 13.8185 4.31607 14.4749 4.87868C15.1313 5.44129 15.5 6.20435 15.5 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			</svg>&nbsp;:</p>
				<strong class="toast-title">${titulo}</strong>
				<div class="flex">
				<p  style="font-weight:500;">COLOR: <p style="font-weight:300; ">&nbsp;${color}</p></p>
				&nbsp;&nbsp;
				<p  style="font-weight:500; ">TALLA: <p style="font-weight:300; ">&nbsp;${talla}</p></p>
				</div>
				<span class="text-custom-toast" >Ir a la bolsa</span>
			</div>
			<div class="toast-image">
				<img src="${image}" alt="product" />
			</div>
		`;
		document.body.appendChild(toast);
		void toast.offsetWidth;
		toast.classList.add('show');
		const button = toast.querySelector('#abrir-cart');
		if (button) {
			button.addEventListener('click', () => {
			this.open(); 
			toast.remove();
			});
		}
		  setTimeout(() => {
			toast.classList.remove('show');
		  toast.classList.add('hide');
		  setTimeout(() => toast.remove(), 500);
		  }, duration);
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		//console.log(html)
		//console.log(selector)
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
			{
				id: "cart-icon-bubble-mobile",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-icon-bubble-mobile",
				section: "cart-icon-bubble-mobile",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

async function updateCart({ openDrawer = true } = {}) {
  const cartDrawer = document.querySelector('cart-drawer');
  const cartItems =
    document.querySelector('cart-drawer-items') ||
    document.querySelector('cart-items');
  if (!cartItems) return;

  const sectionsToRender = cartItems.getSectionsToRender();

  const sectionNames = sectionsToRender.map(
    section => section.section
  );

  const response = await fetch(
    `${routes.cart_url}?sections=${sectionNames.join(',')}`
  );

  if (!response.ok) {
    console.error('Failed to refresh cart');
    return;
  }

  const sections = await response.json();

  sectionsToRender.forEach(section => {
    const container =
      document.getElementById(section.id);

    if (!container || !sections[section.section]) return;

    const html = new DOMParser().parseFromString(
      sections[section.section],
      'text/html'
    );

    const newContent = html.querySelector(section.selector);

    const currentContent =
      container.querySelector(section.selector) ||
      container;

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }
  });


  if (
    openDrawer &&
    cartDrawer &&
    cartItems.tagName.toLowerCase() === 'cart-drawer-items'
  ) {
    cartDrawer.open();
  }
  //closeQuickAddModal();
}
function moneyFormat(nmb){
  let formatoDinero = nmb.toLocaleString('es-MX', {
	style: 'currency',
	currency: 'MXN'
  });
  return formatoDinero
}
function disableCheckout(){
	console.log('Checkout disabled')
	if($('.cart__checkout-button').length > 0){
		$('.cart__checkout-button').attr('prehref',$('.cart__checkout-button').attr('href'))
		$('.cart__checkout-button').attr('href','#')
		$('.cart__checkout-button').addClass('disabled')
	}
}
function enableCheckout(){
	console.log('Checkout enabled')
	if($('.cart__checkout-button').length > 0){
		if($('.cart__checkout-button').attr('href') == '#'){
			$('.cart__checkout-button').attr('href',$('.cart__checkout-button').attr('prehref'))
		}
		$('.cart__checkout-button').removeClass('disabled')
		$('.limit-message').remove()
	}
}
function checkoutMessage(){
	if($('.cart__checkout-button').length > 0){
		if($('.limit-message').length == 0){
			$('.cart__checkout-button').parent().prepend('<p class="limit-message">Algunos de tus artículos se agotaron. Por favor modifica tus compras </p>')
		}
	}
}